module.exports = __webpack_public_path__ + "img/dec14_04.34569fdc.jpeg";